import { defineMessages } from 'react-intl';

export default defineMessages({
  mainMenuAriaLabel: {
    id: 'contentLayout.mainMenuAriaLabel',
    defaultMessage: 'Main menu',
  },
});
